import { Auth, API } from 'aws-amplify';
import Local from './Local';


export default process.env.REACT_APP_APP_ENVIROMENT === 'development' ? new Local() : API
